import { ChartOptions } from "chart.js";
import _ from "lodash";
import { DateTime } from "luxon";
import { Bar } from "react-chartjs-2";

import { makeStyles } from "@material-ui/core";

import palette from "src/styles/palette";

import NumberStat from "../stats/NumberStat";

const useStyles = makeStyles(() => ({
  numberStatRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    flexWrap: "wrap"
  },
  chartWrapper: {
    marginTop: 40,
    height: 400,
    position: "relative"
  }
}));

export default function UsageTimeline({
  startDate,
  endDate,
  data
}: {
  startDate: string;
  endDate: string;
  data: {
    date: string;
    calls: number;
    voicemails: number;
  }[];
}): JSX.Element {
  const classes = useStyles();
  const labels = [];
  const callsSeries = [];
  const voicemailsSeries = [];

  const dataByDay = _.keyBy(data, "date");

  let date = DateTime.fromISO(startDate);
  const endDateParsed = DateTime.fromISO(endDate);
  while (date <= endDateParsed) {
    labels.push(
      date.toLocaleString({
        month: "short",
        day: "numeric"
      })
    );

    const { calls, voicemails } = dataByDay[date.toISODate()] || {
      calls: 0,
      voicemails: 0
    };
    callsSeries.push(calls);
    voicemailsSeries.push(voicemails);

    date = date.plus({ days: 1 });
  }

  const chartData = {
    labels,
    datasets: [
      {
        label: "Calls Made",
        data: callsSeries,
        backgroundColor: palette.darkBlue
      },
      {
        label: "Voicemails Left",
        data: voicemailsSeries,
        backgroundColor: palette.darkGreen
      }
    ]
  };

  const chartOptions: ChartOptions<"bar"> = {
    scales: {
      y: {
        min: 0,
        ticks: {
          precision: 0
        }
      }
    },
    plugins: {
      tooltip: {
        mode: "index",
        intersect: false
      },
      legend: {
        onClick: () => {
          // noop -- disable default behavior of hiding series
          return;
        }
      }
    },
    maintainAspectRatio: false
  };

  return (
    <div>
      <div className={classes.numberStatRow}>
        <NumberStat value={_.sumBy(data, "calls")}>Calls Made</NumberStat>
        <NumberStat value={_.sumBy(data, "voicemails")}>
          Voicemails Left
        </NumberStat>
      </div>
      <div className={classes.chartWrapper}>
        <Bar data={chartData} options={chartOptions} />
      </div>
    </div>
  );
}
